import { render } from "./PlaylistRow.vue?vue&type=template&id=3b44b8fa"
import script from "./PlaylistRow.vue?vue&type=script&lang=js"
export * from "./PlaylistRow.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__